import { render, staticRenderFns } from "./BeneficiaryOption.vue?vue&type=template&id=21eecc38&scoped=true&"
import script from "./BeneficiaryOption.vue?vue&type=script&lang=js&"
export * from "./BeneficiaryOption.vue?vue&type=script&lang=js&"
import style0 from "./BeneficiaryOption.vue?vue&type=style&index=0&id=21eecc38&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21eecc38",
  null
  
)

export default component.exports